import { useTranslation } from "react-i18next";
import {
  navLinks,
  problemStats,
  features,
  testimonials,
  liveMetrics,
  pricingPlans,
  integrations,
  securityFeatures,
  dashboardStats,
  recentCalls,
  tbcspnLayers,
  techStack,
  voiceLatencySteps,
  callerIdFeatures,
  securityProtocols,
  learningCycle,
  howItWorksSteps,
  faqItems,
} from "../mocks/landingData";
import {
  navLinksEn,
  problemStatsEn,
  featuresEn,
  testimonialsEn,
  liveMetricsEn,
  pricingPlansEn,
  integrationsEn,
  securityFeaturesEn,
  dashboardStatsEn,
  recentCallsEn,
  tbcspnLayersEn,
  techStackEn,
  voiceLatencyStepsEn,
  callerIdFeaturesEn,
  securityProtocolsEn,
  learningCycleEn,
  howItWorksStepsEn,
  faqItemsEn,
} from "../mocks/landingData.en";

export function useLandingData() {
  const { i18n } = useTranslation();
  const isEn = i18n.language === "en";

  return {
    navLinks: isEn ? navLinksEn : navLinks,
    problemStats: isEn ? problemStatsEn : problemStats,
    features: isEn ? featuresEn : features,
    testimonials: isEn ? testimonialsEn : testimonials,
    liveMetrics: isEn ? liveMetricsEn : liveMetrics,
    pricingPlans: isEn ? pricingPlansEn : pricingPlans,
    integrations: isEn ? integrationsEn : integrations,
    securityFeatures: isEn ? securityFeaturesEn : securityFeatures,
    dashboardStats: isEn ? dashboardStatsEn : dashboardStats,
    recentCalls: isEn ? recentCallsEn : recentCalls,
    tbcspnLayers: isEn ? tbcspnLayersEn : tbcspnLayers,
    techStack: isEn ? techStackEn : techStack,
    voiceLatencySteps: isEn ? voiceLatencyStepsEn : voiceLatencySteps,
    callerIdFeatures: isEn ? callerIdFeaturesEn : callerIdFeatures,
    securityProtocols: isEn ? securityProtocolsEn : securityProtocols,
    learningCycle: isEn ? learningCycleEn : learningCycle,
    howItWorksSteps: isEn ? howItWorksStepsEn : howItWorksSteps,
    faqItems: isEn ? faqItemsEn : faqItems,
  };
}
